export default __webpack_public_path__ + "static/media/lock-play.9e5f4a19.svg";